<div class="modal-overlay" *ngIf="modalShown"></div>
<div
  appClickOutside
  (clickOutside)="closeModal()"
  class="modal"
  [class.modal--fullscreen]="fullscreen"
  *ngIf="modalShown"
  [@modalDisplay]="!isModalMobile"
  [@modalMobileDisplay]="isModalMobile"
>
  <div class="modal__header">
    <h3>{{ titleText }}</h3>
  </div>

  <div class="modal__content">
    <ng-content></ng-content>
    <p *ngIf="infoText" class="info-warning-text">
      {{ infoText }}
    </p>
  </div>

  <div
    class="modal__footer"
    [ngClass]="{ 'modal__footer--two-buttons': cancelButtonShown }"
  >
    <app-button
      *ngIf="cancelButtonShown"
      (click)="closeModal()"
      buttonType="secondary"
      [text]="cancelButtonText"
    ></app-button>

    <app-button
      (click)="saveModalContent()"
      buttonType="primary"
      [text]="saveButtonText"
    ></app-button>
  </div>
</div>
